import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63d84e98")

_pushScopeId("data-v-63d84e98")
const _hoisted_1 = { class: "row full-width items-center" }
const _hoisted_2 = { class: "row items-center full-width" }
const _hoisted_3 = { class: "col-auto" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" No Data ")
_popScopeId()


import AppDndList from '@/components/common/ui/AppDndList.vue'


export default _defineComponent({
  props: {
  items: {
    type: Array,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  headerTextColor: {
    type: String,
    default: 'grey',
  },
},
  emits: ["onChange"] as unknown as undefined,
  setup(__props) {





return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(AppDndList, {
    group: "audience",
    itemKey: "_id",
    items: __props.items,
    "text-color": __props.headerTextColor,
    onOnChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onChange', $event)))
  }, {
    title: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", {
          class: ["text-caption", 'text-' + __props.headerTextColor]
        }, _toDisplayString(__props.title), 3),
        _createVNode("div", {
          class: ["col", 'horizontal-line-dashed-' + __props.headerTextColor]
        }, null, 2)
      ])
    ]),
    "item-content": _withId(({ item }) => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_q_icon, {
            size: "md",
            name: "svguse:/icons/identity_platform.svg#icon"
          })
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_q_item_section, { class: "q-ml-md" }, {
            default: _withId(() => [
              _createVNode(_component_q_item_label, { class: "title" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_q_item_label, { class: "sub-title" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('label.audience.audience_size')) + ":" + _toDisplayString(item.audience_size), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ])
      ])
    ]),
    empty: _withId(() => [
      _createVNode(_component_q_item, { dense: "" }, {
        default: _withId(() => [
          _createVNode(_component_q_item_section, { size: "" }, {
            default: _withId(() => [
              _createVNode(_component_q_item_label, { class: "title" }, {
                default: _withId(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["items", "text-color"]))
}
}

})